import styled from "styled-components";

export const CommonQuestionsContent = styled.div.attrs({
})`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  `;

export const FaqsContainer = styled.div.attrs({
})`
  border-radius: 22px;
  background: ${p => p.theme.palette.colors.surfaceElevated};
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  box-shadow: 0 18px 42px ${p => p.theme.palette.colors.shadowStrong};

`;

export const Question = styled.div.attrs({
})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  cursor: pointer;
`;

export const Text = styled.div.attrs({
})`
  font-family: Gilroy;
  font-size: 16px;
  font-weight: 600;
  color: ${p => p.theme.palette.colors.text};

`;

export const Answer = styled.div.attrs({
})`  

  padding: 0px 16px 16px;
  border-radius: 0px 0px 8px 8px;
`;
export const TextAnswer = styled.div.attrs({
})`  
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  color: ${p => p.theme.palette.colors.muted};
`;

export const QuestionIcon = styled.img.attrs((props) => (({
  src: '/icons/chevron-down.svg'
})))`
    width: 18px;
    height: 18px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out;
    ${props => props.open ? `transform: rotate(-180deg);`
    : ``
  }
`;

export const CommonTitle = styled.div.attrs({
})`
  font-family: Gilroy;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.08;
  text-align: left;
  color: ${props => props.faq ? props.theme.palette.colors.text : props.theme.palette.colors.white};
  margin-bottom: 8px;
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const MoreInfosContainer = styled.div.attrs({
})`          
    display: flex;
    gap: 40px;
    align-items: center;

    justify-content: center;
    ${p => p.reverse ? `
        flex-direction: row-reverse;
        ` : ``};
    ${p => p.column ? `
        flex-direction: column;
        ` : ``};
    ${p => p.start ? `
           align-items: flex-start;
        ` : ``};
    @media (max-width: 991px){
      justify-content: center;    
      flex-wrap: wrap;
    }
`;
